import { featureToggles } from '@grandvisionhq/www-next/configuration'
import {
  CartSettings,
  InjectedCartProps,
  withCartFactory,
} from '@grandvisionhq/www-next/pages/cart/hoc'

import { deliveryResolverFactory } from '../../util/delivery-resolver-factory'

const { subscriptionDeliveryIntervalsFallback } = featureToggles.featureConfigs

export const settings: CartSettings = {
  deliveryResolverFactory,
  isBackOrderAllowed: true,
  isDiscountCodeEnabled: true,
  maximumQuantity: 10,
  shouldShowCartDiscountOnLineItem: true,
  shouldShowShippingMethod: true,
  shouldShowSubTotal: true,
  shouldShowTotalDiscount: true,
  subscriptionIntervalsFallback: subscriptionDeliveryIntervalsFallback,
  onFinalizedCartError: ({
    resetCallback,
  }: {
    resetCallback: () => void
    navigateTo: (path: string) => void
  }) => {
    resetCallback()
  },
  onUnRecoverableError: ({
    resetCallback,
  }: {
    resetCallback: () => void
    navigateTo: (path: string) => void
  }) => {
    resetCallback()
  },
}

export type { InjectedCartProps }

export const withCart = withCartFactory(settings)
